var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirtime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Airtime",
    transform: "translate(-242 -590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147997",
    "data-name": "Rectangle 147997",
    width: 47,
    height: 46,
    rx: 10,
    transform: "translate(242 590)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M21,13a7,7,0,1,0,7,7A6.994,6.994,0,0,0,21,13Zm5.353,6.588H23.882a12.74,12.74,0,0,0-.741-4.529A5.534,5.534,0,0,1,26.353,19.588ZM21,25.353h0c-.329-.165-1.071-1.482-1.235-4.118h2.388C21.988,23.871,21.329,25.188,21,25.353Zm-1.235-5.765c.082-3.129.906-4.776,1.153-4.941h0c.329.165,1.153,1.812,1.235,4.941Zm-.906-4.529a14.893,14.893,0,0,0-.741,4.529H15.647A5.534,5.534,0,0,1,18.859,15.059Zm-3.047,6.176h2.306a12.871,12.871,0,0,0,.741,3.706A5.547,5.547,0,0,1,15.812,21.235Zm7.329,3.706a12.323,12.323,0,0,0,.741-3.706h2.388A5.891,5.891,0,0,1,23.141,24.941Z",
    transform: "translate(245 593)",
    fill: "#fdfdfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtime);
export default __webpack_public_path__ + "static/media/airtime.d42cbd76ef273ea8d140cc96e559b36f.svg";
export { ForwardRef as ReactComponent };